module.exports = __webpack_public_path__ + "img/tc8ne.bf82ce2e.png";